import ChartType from '@opsbase/lib-chart/ChartType';
import ChartVariant from '@opsbase/lib-chart/ChartVariant';
import OpDataSchema from '@opsbase/lib-data-metamodel/metamodels/OpMetaModel';
import QueryFieldKey from '@opsbase/lib-data-queryfield/QueryFieldKey';
import View from '@opsbase/lib-data-view/View';
import ViewFieldKey from '@opsbase/lib-data-viewfield/ViewFieldKey';
import ViewFieldRegistry from '@opsbase/lib-data-viewfield/ViewFieldRegistry';
import getViewFieldsFromQuestions from '@opsbase/lib-form/helpers/getViewFieldsFromQuestions';
import GradingMethodType from '@opsbase/lib-grading/GradingMethodType';
import Pages from '@opsbase/lib-pages';
import { titleFromDateRange } from '@opsbase/lib-time/utils';
import SelfContext from '@opsbase/react-ctrl-self/useSelf/SelfContext';
import useOpDefinitionFindById from '@opsbase/react-gql-hooks/opdefinition/useOpDefinitionFindById';
import usePlaceFindById from '@opsbase/react-gql-hooks/place/usePlaceFindById';
import useStaffFindById from '@opsbase/react-gql-hooks/staff/useStaffFindById';
import useViewRegistry from '@opsbase/web-ctrl-view/useViewRegistry';
import useViewRegistryActions from '@opsbase/web-ctrl-view/useViewRegistryActions';
import useNav from '@opsbase/web-nav/useNav';
import Spinner from '@opsbase/web-ui/Spinner';
import React, { useContext, useEffect } from 'react';
export function OpsLogOpener(props) {
    const { opDefinitionId, staffId, placeId, startFrom, onComplete, dialog = false } = props;
    const { goTo } = useNav();
    const { allops } = useViewRegistry();
    const { putView } = useViewRegistryActions();
    const { loading: loadingOpDef, data: opDef } = useOpDefinitionFindById({
        variables: { id: opDefinitionId },
        skip: !opDefinitionId,
    });
    const { loading: loadingPlace, data: place } = usePlaceFindById({
        variables: { id: placeId },
        skip: !placeId,
    });
    const { loading: loadingStaff, data: staff } = useStaffFindById({
        variables: { id: staffId },
        skip: !staffId,
    });
    const { language } = useContext(SelfContext);
    useEffect(() => {
        var _a, _b;
        if ((!opDefinitionId || (!loadingOpDef && !!opDef)) &&
            (!placeId || (!loadingPlace && !!place)) &&
            (!staffId || (!loadingStaff && !!staff))) {
            // Create new LMSS
            const view = new View({
                id: 'opsfor' + opDefinitionId || placeId || staffId,
                title: allops.title,
                type: allops.type,
                fields: allops.fields,
                groupBys: [],
                filters: [],
                sortBy: allops.sortBy.key,
                sortByDesc: allops.sortByDesc,
            });
            // If OpDef Log
            if (opDef) {
                view.filters.push({
                    queryFieldKey: QueryFieldKey.OPDEFINITION,
                    id: opDef.id,
                    title: opDef.title,
                    hidden: true,
                    veryHidden: true,
                });
                const opFields = OpDataSchema.fields;
                view.fields = [
                    ViewFieldRegistry[ViewFieldKey.ROWKEY],
                    opFields.find(ff => ff.key === ViewFieldKey.OP_STARTFROM),
                    opFields.find(ff => ff.key === ViewFieldKey.OP_STATUS),
                ];
                if (opDef.isScoreEnabled) {
                    view.fields.push(opFields.find(ff => ff.key === ViewFieldKey.OP_SCORE));
                }
                if (((_a = opDef.gradingMethod) === null || _a === void 0 ? void 0 : _a.gradingMethodType) !== GradingMethodType.NONE) {
                    view.fields.push(opFields.find(ff => ff.key === ViewFieldKey.OP_PASSSTATUS));
                }
                if (((_b = opDef.gradingMethod) === null || _b === void 0 ? void 0 : _b.gradingMethodType) === GradingMethodType.CALCULATED) {
                    view.fields.push(opFields.find(ff => ff.key === ViewFieldKey.OP_GRADE));
                }
                view.fields = [...view.fields, ...getViewFieldsFromQuestions(opDef.form, language)];
                view.chartBox = { visible: false, charts: [] };
                if (opDef.isScoreEnabled) {
                    view.chartBox.visible = true;
                    view.chartBox.charts = [
                        {
                            key: 'scoreChart',
                            chartType: ChartType.BAR3DSTACK,
                            chartVariant: ChartVariant.SCORE_Q_OP,
                            config: {},
                        },
                    ];
                }
            }
            // Place
            if (place) {
                view.filters.push({
                    queryFieldKey: QueryFieldKey.PLACE,
                    id: place.id,
                    title: place.title,
                    frozen: true,
                });
            }
            // Staff
            if (staff) {
                view.filters.push({
                    queryFieldKey: QueryFieldKey.STAFF,
                    id: staff.id,
                    title: staff.title,
                    frozen: true,
                });
            }
            // Start From
            if (startFrom) {
                view.filters.push({
                    queryFieldKey: QueryFieldKey.OP_STARTFROM,
                    title: titleFromDateRange(startFrom[0], startFrom[1]),
                    from: startFrom[0],
                    to: startFrom[1],
                });
            }
            putView(view, true);
            // Done
            goTo(dialog ? Pages.OPS_LOG_DIALOG : Pages.OPS_LOG, { viewId: view.id });
            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
        }
    }, [
        dialog,
        onComplete,
        putView,
        allops,
        goTo,
        opDefinitionId,
        loadingOpDef,
        opDef,
        placeId,
        loadingPlace,
        place,
        startFrom,
        staffId,
        loadingStaff,
        staff,
        language,
    ]);
    return React.createElement(Spinner, null);
}
export default OpsLogOpener;
